// extracted by mini-css-extract-plugin
export default {"container":"styles_container__pWcsw","body":"styles_body__-8eVO"};